import React from 'react'
import Dashboard from './pages/Dashboard'
import { GlobalStyle } from './styles'

function App() {
  return (
    <>
      <GlobalStyle />
      <Dashboard />
    </>
  )
}

export default App
